import React from "react"
import { Link } from "gatsby"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import CarnivalCard from "../../components/CarnivalCard";
import HourGlass from "../../images/hourGlass.svg";
import Group from "../../images/group.svg";
import Difficulty from "../../images/difficulty.svg";
import Age from "../../images/age.svg";

const Carnival = () => (
  <Layout location="townsville">
    <SEO title="Carnival" description="Coming Soon" />
    <div style={{ display: "flex", marginTop: 50, flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 35%", minWidth: "350px" }}>

            <p>Step right up ladies and gentleman to the greatest show you’ll ever see.</p>
            
            <p>Mr whitlocks carnival has been travelling all over the country and has finally landed in your town.
            You’ll have so much fun that you might never leave.</p>
            
            <p>Step through the gates and enjoy yourself.</p>

            <p>Please note that this room has some confined spaces, atleast one member must be able to operate in them.</p>
            <p>Additionally we ask that people with pace makers do not complete this room.</p>

            <div className="adventure-summary-container">
                <div className="adventure-summary-row">
                    <img src={Group} height="24" />
                    <div className="adventure-label">How many</div>
                    <div>3 - 6</div>
                </div>
                <div className="adventure-summary-row">
                    <img src={HourGlass} height="24" />
                    <div className="adventure-label">Duration</div>
                    <div>60 minutes</div>
                </div>
                <div className="adventure-summary-row">
                    <img src={Difficulty} height="24" />
                    <div className="adventure-label">Difficulty</div>
                    <div>7/10</div>
                </div>
                <div className="adventure-summary-row">
                    <img src={Age} height="24" />
                    <div className="adventure-label">Age</div>
                    <div>8+ <small>(U13s must be accompanied by an adult)</small></div>
                </div>
            </div>
        </div>
        <CarnivalCard hideMore={true} />
    </div>
  </Layout>
)

export default Carnival
